import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants";
import { CreateAnnouncementRequestBody } from "./createAnnouncement.types";

export const requestCreateAnnouncement = async (
  body: CreateAnnouncementRequestBody
): Promise<void> => {
  return await instance.post(ApiRoutesContent.Announcement, body);
};
